<div class="rbac-page">
  <div class="rbac-page__header">
    <div>
      <button type="button" class="rbac-back" (click)="back.emit()">&larr; Back to Sub-Modules</button>
      <h4>Inner Modules — {{ subModule.name }}</h4>
      <p class="rbac-page__breadcrumb">{{ module.name }} &rsaquo; {{ subModule.name }}</p>
    </div>
    <button type="button" class="rbac-btn rbac-btn--primary" (click)="openAdd()">+ Add Inner Module</button>
  </div>

  <app-rbac-table
    [columns]="columns"
    [rows]="innerModules"
    [loading]="loading"
    emptyMessage="No inner modules for this sub-module yet."
    (edit)="openEdit($event)"
    (delete)="onDelete($event)"
    (toggleStatus)="onToggleStatus($event)">
  </app-rbac-table>
</div>

<app-rbac-modal [open]="modalOpen" (closed)="closeModal()">
  <div class="im-form">
    <h5>{{ editingInnerModule?.id || editingInnerModule?._id ? 'Edit Inner Module' : 'Add Inner Module' }}</h5>

    <!-- Basic fields via rbac-form -->
    <app-rbac-form
      [title]="''"
      [fields]="fields"
      [model]="editingInnerModule"
      [saving]="saving"
      (save)="onSave($event)"
      (cancel)="closeModal()">

      <!-- Modal Field Builder (shown below the form when type is 'modal') -->
      <ng-container >
        <div class="im-field-builder">
          <div class="im-field-builder__header">
            <h6>Modal Fields</h6>
            <button type="button" class="rbac-btn rbac-btn--small" (click)="addModalField()">+ Add Field</button>
          </div>

          <div class="im-field-builder__list" *ngIf="editingModalFields.length; else noFields">
            <div class="im-field-row" *ngFor="let field of editingModalFields; let i = index">
              <input
                type="text"
                class="im-field-row__input"
                [(ngModel)]="field.id"
                placeholder="Field ID (e.g. name)" />
              <input
                type="text"
                class="im-field-row__input"
                [(ngModel)]="field.placeholder"
                placeholder="Placeholder text" />
              <label class="im-field-row__toggle">
                <input type="checkbox" [(ngModel)]="field.dropdown" />
                <span>Dropdown</span>
              </label>
              <button
                type="button"
                class="im-field-row__remove"
                title="Remove field"
                (click)="removeModalField(i)">
                &times;
              </button>
            </div>
          </div>

          <ng-template #noFields>
            <p class="im-field-builder__empty">No fields defined yet. Click "+ Add Field" to start.</p>
          </ng-template>
        </div>
      </ng-container>
    </app-rbac-form>
  </div>
</app-rbac-modal>
